import React from 'react'
import { motion } from 'framer-motion'
import Features from '../components/Features'
import SEO from '../components/SEO'

const FeaturesPage: React.FC = () => {
  return (
    <>
      {/* Component-based SEO for Features Page */}
      <SEO url="https://logicloud.mx/features" type="website" />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Features />
      </motion.div>
    </>
  )
}

export default FeaturesPage

